import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DatepickerOption, DatepickerOptions } from './nebula-datepicker.options';

@Component({
  selector: 'nebula-datepicker',
  template: `
    <nebula-datepicker-wrapper [control]="control" [maxDate]="max" [minDate]="min"
        [label]="label" [hasNever]="hasNever"></nebula-datepicker-wrapper>
    `,
})
export class NebulaDatepickerComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() options: Array<DatepickerOption> = [];
  @Input() max: Date;
  @Input() min: Date;

  public hasNever = false;

  constructor() { }

  ngOnInit() {
    this.hasNever = this.options.includes(DatepickerOptions.NEVER);
  }
}
